/// <reference path="../typings/jqueryui/jqueryui.d.ts"/>

((($:JQueryStatic) => {

    $.ajaxSetup({ cache: false });

    $.fn.currencyInput = function() {
        this.each(function() {
            const wrapper = $("<div class='currency-input' />");
            $(this).wrap(wrapper);
            $(this).before("<span class='currency-symbol'>$</span>");
            $(this)
                .change(function() {
                    let value = $(this).val();
                    value = (Math.round(parseFloat(value) * 100) / 100).toFixed(2);
                    $(this).val(value);
                });
        });
    };

    class ContactEditor {
        private contactEditorContainer: JQuery;
        private aboveContactEditorContainer: JQuery;
        constructor(contactEditorContainer, aboveContactEditorContainer) {

            this.contactEditorContainer = contactEditorContainer;
            this.aboveContactEditorContainer = aboveContactEditorContainer;

            const self = this;

            this.contactEditorContainer.on("click",
                "[data-usage='change_selected_contact']",
                function(e) {
                    e.preventDefault();
                    const link = $(this);

                    const contactType = self.getContactType();

                    // Clear the selected contact
                    self.setContact(null, contactType);

                    const url = link.data("url"); // ContactController.ContactEditorClear
                    Ahb.Utilities.ajaxGetData({
                        url: url,
                        requestData: {
                            contactType: contactType,
                            allowedType: self.getAllowedType(),
                            aboveContactId: self.getContactId(self.aboveContactEditorContainer),
                            aboveContactType: self.getContactType(self.aboveContactEditorContainer)
                        },
                        loaderSelector: link.parent().find("[data-usage='loader']"),
                        triggerElement: link,
                        containerSelector: self.contactEditorContainer
                            .find("[data-usage='contact_editor_updatable_container']")
                    });
                });

            this.contactEditorContainer.on("click",
                "[data-usage='set_contact_to_above']",
                function() {
                    const triggerElem = $(this);
                    self.setContact(self.getContactId(self.aboveContactEditorContainer),
                        self.getContactType(self.aboveContactEditorContainer));
                    self.refreshUpdatableContainer(triggerElem);
                });

            this.contactEditorContainer.on("click",
                "[data-usage='set_contact_to_type']",
                function() {
                    const triggerElem = $(this);
                    const contactType = triggerElem.data("contact_type");
                    self.setContact(null, contactType);
                    self.refreshUpdatableContainer(triggerElem);
                });

            //Make enter in search textbox fire click event of find button
            //Done on keyup incase the user holds the key down don't want to be calling whatever the click does multiple times.
            this.contactEditorContainer.on("keyup",
                "[data-usage='contact_search_input']",
                event => {
                    this.setControlState();
                    if (event.keyCode === 13 && this.isSearchAllowed()) {
                        this.performSearch();
                    }
                });

            //Prevent postback on enter key pressed in a textbox within a form
            this.contactEditorContainer.on("keydown",
                "[data-usage='contact_search_input']",
                event => (event.keyCode !== 13));

            this.contactEditorContainer.on("click",
                "[data-usage='contact_search_button']",
                () => {
                    this.performSearch();
                });

            this.contactEditorContainer.on("click",
                "button[data-usage='contact_select']",
                function() {
                    const button = $(this);
                    const contactId = button.data("contact_id");
                    const contactType = button.data("contact_type");
                    self.setContact(contactId, contactType);
                    self.refreshUpdatableContainer();
                });

            this.contactEditorContainer.on("click",
                "button[data-usage='add_contact']",
                function() {
                    const button = $(this);
                    Ahb.Utilities.showAddContactDialog(button,
                        (form, data) => {
                            self.setContact(data.ContactId, data.ContactType);
                            self.refreshUpdatableContainer();
                        });
                });

            this.aboveContactEditorContainer.on("contactchanged",
                () => {
                    // This only has an effect if there's no contact already selected
                    if (!this.contactEditorContainer.find("[data-usage='contact_id_value']").val()) {
                        this.refreshUpdatableContainer();
                    }
                });
        }

        getDefaultContactType(allowedType) {
            allowedType = allowedType || this.getAllowedType();
            switch (allowedType) {
            case "OrganisationOnly":
                return "Organisation";
            default:
                return "Person";
            }
        };

        setContact(contactId, contactType) {
            this.contactEditorContainer.find("[data-usage='contact_id_value']").val(contactId);
            this.contactEditorContainer.find("[data-usage='contact_type_value']").val(contactType);
            this.contactEditorContainer.trigger("contactchanged");
        };

        getContactId(contactEditorContainer?:JQuery) {
            contactEditorContainer = contactEditorContainer || this.contactEditorContainer;
            return contactEditorContainer.find("[data-usage='contact_id_value']").val();
        };

        getContactType(contactEditorContainer?:JQuery) {
            contactEditorContainer = contactEditorContainer || this.contactEditorContainer;
            return contactEditorContainer.find("[data-usage='contact_type_value']").val();
        };

        getAllowedType() {
            return this.contactEditorContainer.data("allowed_type");
        };

        setAllowedType(allowedType) {
            this.contactEditorContainer.data("allowed_type", allowedType);

            const contactType = this.getDefaultContactType(allowedType);
            this.setContact(null, contactType);

            this.clearSearchResults();
            this.setControlState();
            this.refreshUpdatableContainer();
        };

        clearSearchResults() {
            this.contactEditorContainer.find("[data-usage='search_result_container']").empty();
        };

        refreshUpdatableContainer(triggerElement?) {
            const updatableContainer = this.contactEditorContainer.find("[data-usage='contact_editor_updatable_container']");
            const url = updatableContainer.data("url"); // ContactController.ContactEditorUpdatable

            const requestData = {
                contactId: this.getContactId(),
                contactType: this.getContactType(),
                allowedType: this.getAllowedType(),
                aboveContactId: this.getContactId(this.aboveContactEditorContainer),
                aboveContactType: this.getContactType(this.aboveContactEditorContainer)
            };

            Ahb.Utilities.ajaxGetData({
                url: url,
                requestData: requestData,
                loaderSelector: updatableContainer.children("[data-usage='loader']"),
                triggerElement: triggerElement,
                containerSelector: updatableContainer
            });
        };

        isSearchAllowed() {
            const inputElem = this.contactEditorContainer.find("[data-usage='contact_search_input']");
            const searchText = inputElem.val() || "";
            return searchText.length >= 2;
        };

        performSearch() {
            const searchButton = this.contactEditorContainer.find("[data-usage='contact_search_button']");
            const inputElem = this.contactEditorContainer.find("[data-usage='contact_search_input']");
            const url = searchButton.data("url"); // ContactController.FindAllContacts
            const self = this;
            Ahb.Utilities.ajaxGetData({
                url: url,
                requestData: {
                    query: inputElem.val(),
                    contactType: self.getContactType()
                },
                triggerElement: searchButton,
                containerSelector: self.contactEditorContainer.find("[data-usage='search_result_container']"),
                callback: () => {
                    this.contactEditorContainer.find("[data-usage='add_contact_container']").show();
                }
            });
        };

        setControlState() {
            const searchButton = this.contactEditorContainer.find("[data-usage='contact_search_button']");
            searchButton.prop("disabled", !this.isSearchAllowed());
            this.contactEditorContainer.find("input[type='radio']:checked").parents("label").addClass("selected");
            this.contactEditorContainer.find("input[type='radio']:not(:checked)").parents("label").removeClass("selected");
        };
    }

    $.fn.contactEditor = function (options) {
        const settings = $.extend({
            aboveContactEditorSelector: null
        }, options);

        const aboveContactEditorContainer = $(settings.aboveContactEditorSelector);

        return this.each(function () {
            const contactEditorContainer = $(this);
            const contactEditor = new ContactEditor(contactEditorContainer, aboveContactEditorContainer);
            contactEditorContainer.data("contact_editor", contactEditor);
        });
    };

    $.fn.openSearchPersonDialog = function (options) {

        const settings = $.extend({
            personIdSelector: null,
            personNameSelector: null,
            closeCallback: null
        }, options);

        return this.each(function () {
            const button = $(this);

            button.click(function () {

                const personIdCtrl = $(this).parent().find(settings.personIdSelector).first();
                const personNameCtrl = $(this).parent().find(settings.personNameSelector).first();

                const dialog = $(`#${button.data("dialogid")}`);

                dialog.insiteDialog({
                    autoHeight: true,
                    saveButtonName: "OK",
                    openCallback: () => {
                        $("[data-usage='contact_editor_container']:visible").contactEditor();
                    },
                    saveCallback: form => {
                        const contactDetailContainer = form.find("[data-usage='contact_detail_container']");
                        const personId = contactDetailContainer.data("contact_id");
                        const personName = contactDetailContainer.data("contact_name");

                        personIdCtrl.val(personId);
                        personNameCtrl.val(personName);

                        if (settings.closeCallback) {
                            settings.closeCallback(personId, personName, personIdCtrl);
                        }

                    }
                });

            });

        });
    };

    $.fn.updateExpandos = function (options) {

        const settings = $.extend({
            targetElementGetter: arrowElem => $(arrowElem).closest("tr").next(),
            expandedCallback: null,
            collapsedCallback: null
        }, options);

        return this.each(function () {
            const expando = $(this);

            const arrow = expando.find(".arrow");

            const expandoData = {
                expanded: arrow.hasClass("arrow-down"),
                setExpanded: null
            };

            function refreshExpandedState() {
                let isChanged = false;
                const targetElements = settings.targetElementGetter(expando);

                if (expandoData.expanded) {
                    while (arrow.hasClass("arrow-right")) {
                        arrow.removeClass("arrow-right");
                        isChanged = true;
                    }

                    if (!arrow.hasClass("arrow-down")) {
                        arrow.addClass("arrow-down");
                        isChanged = true;
                    }

                    targetElements.each(function () {
                        $(this).show();
                    });

                    if (isChanged && settings.expandedCallback) {
                        settings.expandedCallback(expando, targetElements);
                    }
                } else {
                    while (arrow.hasClass("arrow-down")) {
                        arrow.removeClass("arrow-down");
                        isChanged = true;
                    }

                    if (!arrow.hasClass("arrow-right")) {
                        arrow.addClass("arrow-right");
                        isChanged = true;
                    }

                    targetElements.each(function () {
                        $(this).hide();
                    });

                    if (isChanged && settings.collapsedCallback) {
                        settings.collapsedCallback(expando, targetElements);
                    }
                }
            }

            expandoData.setExpanded = expanded => {
                expandoData.expanded = expanded;
                refreshExpandedState();
            };

            expando.data("expando_data", expandoData);

            settings.targetElementGetter(expando).each(function () {
                const targetElement = $(this);
                targetElement.data("expando_parent", expandoData);
            });

            expando.click(() => {
                expandoData.setExpanded(!expandoData.expanded);
            });
        });
    };

    $.fn.collapseAllExpando = function () {

        return this.each(function () {

            const arrow = $(this).find(".arrow");

            if (arrow.hasClass("arrow-down")) {
                $(this).click();
            }
        });
    };

    $.fn.expandAllExpando = function () {

        return this.each(function () {

            const arrow = $(this).find(".arrow");

            if (arrow.hasClass("arrow-right")) {
                $(this).click();
            }
        });
    };

    $.fn.scrollToTop = function (smooth) {
        if (this.offset()) {
            const cTop = this.offset().top;

            if (smooth) {
                $("body").animate({ 'scrollTop': cTop - 100 }, "slow", "swing");
            } else {
                $(window).scrollTop(cTop - 100);
            }
        }
    };

    $.fn.clickForPost = function (options) {

        const settings = $.extend({
            url: null,
            containerSelector: null,
            callback: null,
            suppressValidation: false,
            cleanupOnReplace: true,
            beforePost: null,
            loaderSelector: null,
            formSelector: null,
            dataProcessor: data => data
        }, options);

        return this.each(function () {
            const button = $(this);
            button.on("click", () => {

                $(settings.beforePost);

                const ajaxSettings = $.extend(settings, {
                    triggerElement: button
                });

                Ahb.Utilities.ajaxPostForm(ajaxSettings);
            });
        });
    };

    $.fn.clickForGet = function (options) {

        const settings = $.extend({
            url: null,
            id: -1,
            containerSelector: null,
            callback: null
        }, options);

        return this.each(function () {
            const clickableElem = $(this);
            clickableElem.click(() => {

                const ajaxSettings = $.extend(settings, {
                    triggerElement: clickableElem
                });

                Ahb.Utilities.ajaxGetData(ajaxSettings);
            });
        });
    };

    $.fn.scanValidationScripts = function () {
        return this.each(function () {
            Ahb.Utilities.scanValidationScripts($(this));
        });
    };

    $.fn.htmlWithValidation = function (data) {

        const html = $.parseHTML(data, null, true);
        Ahb.Utilities.scanValidationScripts(html);

        return this.each(function () {
            // Empty and append, to avoid parsing the data a second time
            $(this).empty().append(html);
            Ahb.Utilities.updateValidationConfiguration();
        });

    };

    $.fn.selectAllConfirmed = function (filter: String, options) {

        const settings = $.extend({
            checkboxes: [],
            title: "Confirm Selection",
            message: "Are you sure you want to select all?",
            onclose: null
        }, options);

        return this.on("click", filter, (event) => {
                const checkbox = $(event.target);
                const checkboxes = settings.checkboxes != null ? settings.checkboxes : [];

                if (!checkbox.prop("checked")) {
                    $(checkboxes).each(function () {
                        $(this).prop("checked", false);
                    });
                    if (settings.onclose != null) settings.onclose();
                    return;
                }

                // Show confirmation dialog.
                const dialogContainerName = checkbox.attr("id") + "ConfirmSelectAllDialogContainer";
                const dialogContainerSelector = `#${dialogContainerName}`;

                Ahb.Utilities.ensureDivExists(dialogContainerName);

                $(dialogContainerSelector)
                    .attr("id", dialogContainerName)
                    .empty()
                    .append(`<div style="padding:6px;">${settings.message}</div>`);

                $(dialogContainerSelector).dialog({
                    resizable: false,
                    height: 140,
                    modal: true,
                    title: settings.title,
                    close: () => {
                        if (settings.onclose != null) settings.onclose();
                    },
                    buttons: {
                        "Yes": function () {
                            $(checkboxes).each(function () {
                                $(this).prop("checked", true);
                            });
                            $(this).dialog("close");
                        },
                        "No": function () {
                            checkbox.prop("checked", false);
                            $(this).dialog("close");
                        }
                    }
                });

            });
    };

    $.fn.insiteDialog = function (options) {

        const settings = $.extend({
            title: "[Title Not Set]",
            saveButtonName: "Save",
            cancelButtonName: "Cancel",
            preSaveCallback: null,
            saveCallback: null,
            closeCallback: null,
            openCallback: null,
            alternativeSaveCommands: [{
                buttonName: "DUMMY",
                callback: null,
                url: null,
                data: null
            }],
            focusOnFirstSelectElement: false,
            autoWidth: false,
            autoHeight: false,
            formEncodingType: null
        }, options);

        return this.each(function () {

            const dialogElement = $(this);

            // Don't re-display if the dialog is already open. Instead behave as if the dialog
            // were opened and then closed by the user. I.e. call the close callback.
            if (dialogElement.data("ui-dialog") && (dialogElement.dialog("isOpen"))) {
                if (settings.closeCallback) {
                    settings.closeCallback();
                }

                return;
            }

            const formId = dialogElement.data("formid");

            let width = "auto";
            let height = "auto";
            if (!settings.autoWidth) {
                width = dialogElement.data("width");
            }

            if (!settings.autoHeight) {
                height = dialogElement.data("height");
            }

            const url = dialogElement.data("url");
            const validate = dialogElement.data("validate");
            const calendarImageUrl = dialogElement.data("calendarimageurl");

            let title = dialogElement.attr("title");
            if (settings.title && settings.title !== "[Title Not Set]") {
                title = settings.title;
            }

            // Create containers in the body to keep track of dialog elements
            const originalDialogContainer = dialogElement.parent();

            // Destroy any existing datepicker widgets before copying
            dialogElement.find(".datepicker").datepicker("destroy");

            // Detach so that we can clone without conflicting IDs.
            dialogElement.detach();

            // Create a copy of the original for display, so that the original does not get changed.
            const dialogElementCopy = dialogElement.clone().attr("title", title);

            // Detach the dialog contents so that we can wrap them in a form element
            const dialogContentsCopy = dialogElementCopy.children().detach();

            // Create a form element to contain the dialog contents
            const form = $("<form>").attr("id", formId).attr("action", url).attr("method", "post");
            if (settings.formEncodingType) form.attr("enctype", settings.formEncodingType);

            // Build up the dialog containing the form, as children of the body element
            $("body").append(dialogElementCopy);
            dialogElementCopy.append(form);
            form.append(dialogContentsCopy);

            // See if any initialisation needs to be done
            dialogElement.find("[data-usage='dialog_initialisation_metadata']").each((index, initMetadataElem) => {
                const initialisationFunction = $(initMetadataElem).data("dialog_initialisation_function");
                if (initialisationFunction) {
                    const fn: any = window[initialisationFunction];
                    if (typeof fn === "function")
                        fn();
                }
            });

            // Create an array of save commands based on whether the caller has specified
            // an alternative collection.
            const hasAlternativeSaveCommands = settings.alternativeSaveCommands &&
                settings.alternativeSaveCommands.length &&
                settings.alternativeSaveCommands[0].buttonName !== "DUMMY";

            const saveCommands = hasAlternativeSaveCommands ? settings.alternativeSaveCommands : [{
                buttonName: settings.saveButtonName
            }];

            // Set up the buttons for the dialog
            const buttons:{[buttonText:string]:(event?:Event) => void;} = {};

            // Save buttons
            $.each(saveCommands, (index, saveCommand) => {
                buttons[saveCommand.buttonName] = e => {
                    if (settings.preSaveCallback) {
                        if (settings.preSaveCallback(form) === false) {
                            return;
                        }
                    }

                    const clickedButton = $(e.target).closest("button");

                    // It's still possible to click a disabled button on a jQuery dialog box.
                    // Don't save if the button is disabled.
                    if (clickedButton.attr("disabled")) {
                        return;
                    }

                    const isValid = !validate || form.validate().form();
                    if (isValid) {
                        const postUrl = saveCommand.url || settings.url || url;
                        const callback = saveCommand.callback || settings.saveCallback || (() => { });

                        if (postUrl) {
                            // If data has been specified as part of the save command, use that.
                            // Otherwise assume we're posting form data.
                            const postData = saveCommand.data || form.serialize();

                            Ahb.Utilities.ajaxPostData({
                                url: postUrl,
                                data: postData,
                                triggerElement: clickedButton,
                                callback: data => {
                                    callback(form, data);
                                    dialogElementCopy.dialog("close");
                                },
                                loaderSelector: null
                            });
                        } else {
                            callback(form);
                            dialogElementCopy.dialog("close");
                        }
                    }
                };
            });

            // Cancel button (if it exists)
            if (settings.cancelButtonName) {
                buttons[settings.cancelButtonName] = () => {
                    dialogElementCopy.dialog("close");
                };
            }

            dialogElementCopy.show();
            dialogElementCopy.dialog({
                width: width,
                height: height,
                modal: true,
                buttons: buttons,
                open: () => {
                    if (validate) {
                        // As the form is newly created, it won't have any validation configured. Do that now.
                        Ahb.Utilities.updateValidationConfiguration();
                    }

                    // Set up date pickers
                    dialogElementCopy.find(".datepicker").attachDatePickers({ datepickerButtonImageUrl: calendarImageUrl });

                    // Button positioning
                    $(".ui-dialog-buttonset").removeClass().addClass("float-left");

                    // Cancel button styling
                    if (settings.cancelButtonName) {
                        $(".ui-dialog-buttonpane").find(`button:contains("${settings.cancelButtonName}")`).removeClass().addClass("btn").addClass("btn-cancel");
                    }

                    // Save button styling
                    $.each(saveCommands, (index, saveCommand) => {
                        $(".ui-dialog-buttonpane").find(`button:contains("${saveCommand.buttonName}")`).removeClass().addClass("btn").addClass("btn-submit");
                    });

                    // Trigger a click rather than a submit when user hits enter
                    // http://stackoverflow.com/a/13522434
                    form.keypress(e => {
                        let tagName = e.target.tagName.toLowerCase();

                        tagName = (tagName === "input" && e.target.getAttribute("type") === "button") ? "button" : tagName;

                        if (e.which === $.ui.keyCode.ENTER && tagName !== "textarea" && tagName !== "select" && tagName !== "button") {
                            e.preventDefault();

                            if (saveCommands.length === 1) {
                                $(".ui-dialog-buttonpane").find(`button:contains("${saveCommands[0].buttonName}")`).trigger("click");
                            }

                            return false;
                        }
                        return true;
                    });

                    if (settings.focusOnFirstSelectElement) {
                        // Remove focus on all buttons within the
                        // div with class ui-dialog
                        $(".ui-dialog :button").blur();
                        dialogElementCopy.find("select").first().focus();
                    }

                    if (settings.openCallback) {
                        settings.openCallback();
                    }
                },
                close: function () {
                    // Remove the dialog, and add the original dialog element back to the DOM
                    originalDialogContainer.append(dialogElement);
                    $(this).dialog("destroy").remove();

                    if (settings.closeCallback) {
                        settings.closeCallback();
                    }
                }
            });
        });
    };


    $.fn.insiteAlertDialog = function (options) {

        const settings = $.extend({
            buttonName: "OK",
            closeCallback: null,
            openCallback: null,
            autoWidth: false,
            autoHeight: false
        }, options);

        return this.each(function () {

            const dialogElement = $(this);

            const buttons:{[buttonText:string]:(event?:Event) => void;} = {};

            buttons[settings.buttonName] = () => {
                dialogElement.dialog("close");
            };

            let width = "auto";
            let height = "auto";
            if (!settings.autoWidth) {
                width = dialogElement.data("width");
            }

            if (!settings.autoHeight) {
                height = dialogElement.data("height");
            }

            dialogElement.dialog({
                modal: true,
                buttons: buttons,
                width: width,
                height: height,
                open: () => {
                    // Button positioning
                    $(".ui-dialog-buttonset").removeClass().addClass("float-left");

                    $(".ui-dialog-buttonpane").find('button:contains("OK")').removeClass().addClass("btn");

                    $(".ui-dialog-buttonpane").find(`button:contains("${settings.buttonName}")`).removeClass().addClass("btn").addClass("btn-submit");

                    if (settings.openCallback) {
                        settings.openCallback();
                    }
                },
                close: () => {
                    if (settings.closeCallback) {
                        settings.closeCallback();
                    }
                }
            });
        });
    };

    $.fn.showTitleAsInformation = function () {
        return this.each(function () {
            const elem = $(this);

            // Clear any info data already on the element.
            elem.removeClass("hover-defaultcursor").find("[data-titleinfo=true]").remove();

            const title = elem.attr("title");
            if (title) {
                elem.addClass("hover-defaultcursor")
                    .append($("<span>").attr("data-titleinfo", "true").html(" "))
                    .append($("<span>").attr("class", "hover-defaultcursor icon-info-sign").attr("data-titleinfo", "true"));
            }
        });
    };

    $.fn.focusNextInputField = function () {
        return this.each(function () {
            const fields = $(this).parents("form:eq(0),body").find("button,input[type=text],textarea,select");
            const index = fields.index(this);
            if (index > -1 && (index + 1) < fields.length) {
                fields.eq(index + 1).focus();
            }
            return false;
        });
    };

    $.fn.numericInput = function (options) {

        const settings = $.extend({
            precision: null,
            maxPlaces: null
        }, options);

        return this.each(function () {

            const textBox = $(this);
            textBox.keydown(function (event) {

                const input = $(this).val().toString();
                const decimalPos = input.indexOf(".");
                const hasDecimal = decimalPos > -1;

                if
                // Allow: backspace, delete, tab, escape, and enter
                (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 || event.keyCode === 13 ||
                    // Allow: Ctrl+A
                    (event.keyCode === 65 && event.ctrlKey) ||
                    // Allow: Ctrl+V
                    (event.keyCode === 86 && event.ctrlKey) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39) ||
                    // Allow period, if one doesn't already exist and decimal places are allowed.
                    ((event.keyCode === 110 || event.keyCode === 190) && settings.maxPlaces !== 0 && !hasDecimal)) {

                    // let it happen, don't do anything
                    return;
                }

                // If not a number, don't allow keypress.
                if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }

                // At this point we have a number. Do any length/precision validation.
                if (settings.precision != null && (input.length - (hasDecimal ? 1 : 0) === settings.precision)) event.preventDefault();
                if (settings.maxPlaces != null && hasDecimal && input.length - decimalPos > 2 && this.selectionStart > decimalPos) event.preventDefault();
            });
        });
    };

    $.fn.numeric2dp = function () {
        return this.each(function () {

            const textBox = $(this);
            textBox.keydown(function (event) {

                const input = $(this).val().toString();
                const inputArray = input.split(".");


                // Allow: backspace, delete, tab, escape, and enter
                if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 || event.keyCode === 13 ||
                        // Allow: Ctrl+A
                        (event.keyCode === 65 && event.ctrlKey) ||
                        // Allow: home, end, left, right
                        (event.keyCode >= 35 && event.keyCode <= 39) ||
                        ((event.keyCode === 110 || event.keyCode === 190) && inputArray.length < 2)
                ) {
                    // let it happen, don't do anything
                    return;
                }
                // Ensure that it is a number and stop the keypress
                else if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
                else if (inputArray[1] != null && inputArray[1].length > 1 && this.selectionStart > input.indexOf(".")) {
                    event.preventDefault();
                }
            });
        });
    };

    $.fn.textupdate = function (handler) {
        return this.each(function () {
            const textBox = $(this);
            textBox.on("change keyup paste", handler);
            textBox.on("keypress", () => {
                // Keypress event occurs before text changes so use a timeout
                setTimeout(handler, 1);
            });
        });
    };

    // This is an alternative to the jQuery Validate framework's $.valid() function. The difference is
    $.fn.tryValidate = function () {
        return this.each(function () {
            let validator;
            if ($(this).is("form")) {
                validator = $(this).data("validator");
                if (validator) {
                    validator.form();
                }
            } else {
                validator = $(this).closest("form").data("validator");
                if (validator) {
                    validator.element(this);
                }
            }
        });
    };

    $.fn.lazyChosen = function (options) {
        const settings = $.extend({
            sourceSelector: null
        }, options);

        return this.each(function () {
            const dropDown = $(this);
            dropDown.chosen(settings);
            dropDown.on("chosen:showing_dropdown", () => {
                if (!dropDown.data("populated")) {
                    // Store the selected value because we'll be replacing the contents.
                    const selectedVal = dropDown.val();

                    // Repopulate the drop-down from the source drop-down.
                    const sourceDropDown = $(settings.sourceSelector);
                    dropDown.html(sourceDropDown.html());

                    // Reinitialise the jQuery Chosen presentation.
                    Ahb.Utilities.rechosen(dropDown, settings);

                    // Reselect the previously-selected value
                    if (selectedVal) {
                        dropDown.val(selectedVal);
                        dropDown.trigger("chosen:updated");
                    }

                    // Mark the drop-down as populated so we don't try to populate it again
                    dropDown.data("populated", true);

                    // Redisplay the drop-down *after* marking it as populated to prevent infinite recursion
                    dropDown.data("chosen").results_show();
                }
            });

            const lazyChosen = {
                ensureOptionExists(val) {
                    // The drop-down may not be populated yet. If it isn't, just add the necessary option and don't flag
                    // it as populated. It only needs to be fully populated it it is dropped down.
                    if (!dropDown.data("populated") && dropDown.find(`option[value='${val}']`).length === 0) {
                        const sourceDropDown = $(settings.sourceSelector);
                        sourceDropDown.find(`option[value='${val}']`).clone().appendTo(dropDown);
                        Ahb.Utilities.rechosen(dropDown, settings);
                    }
                }
            };

            dropDown.data("lazyChosen", lazyChosen);
        });
    };

})(jQuery));



// WEBPACK FOOTER //
// ./ScriptsTS/AhbHelper.ts